export default __webpack_public_path__ + "static/media/2016-JB.ea923ed5.jpg";